import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const Daily_withdraw = () => {
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [statusFilter, setStatusFilter] = useState("Pending");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userIdSearch, setUserIdSearch] = useState("");
  const [activeRange, setActiveRange] = useState(""); // tracks Today / This Month button
  const currentPage = useRef(1);

  useEffect(() => {
    getPaginatedUsers();
  }, [limit, startDate, endDate, statusFilter]);

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  // ── Quick date range buttons ──
  const handleToday = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    setStartDate(start);
    setEndDate(end);
    setActiveRange("today");
    currentPage.current = 1;
  };

  const handleThisMonth = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
    setStartDate(start);
    setEndDate(end);
    setActiveRange("month");
    currentPage.current = 1;
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusFilter("Pending");
    setLimit(10);
    setUserIdSearch("");
    setActiveRange("");
    currentPage.current = 1;
  };

  const handleApprovePayment = async (depositId, status, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_withdraw_update`, {
        depositId, status
      });
      if (response.status === 200) {
        alert(response.data.message);
        getPaginatedUsers();
      } else {
        alert(`Failed: ${response.data.message}`);
      }
    } catch (error) {
      console.error('Error approving payment:', error);
      alert('Error: ' + error.message);
    }
  };

  const getPaginatedUsers = async () => {
    const formattedStartDate = startDate ? startDate.toISOString() : "";
    const formattedEndDate = endDate ? endDate.toISOString() : "";
    try {
      const response = await axios.get(`${apiConfig.baseURL}/api/agent/daily_withdraw`, {
        params: {
          page: currentPage.current,
          limit: limit,
          status: statusFilter === 'all' ? undefined : statusFilter,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        }
      });
      if (response.status === 200) {
        const resData = response.data;
        setPageCount(resData.pageCount);
        const sortedData = resData.result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setData(sortedData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Error fetching data: ' + error.message);
    }
  };

  // ── Client-side user ID filter ──
  const filteredData = useMemo(() => {
    if (!userIdSearch.trim()) return data;
    return data.filter(d =>
      String(d.user_id).toLowerCase().includes(userIdSearch.trim().toLowerCase())
    );
  }, [data, userIdSearch]);

  // ── Summary totals ──
  const displayedTotal = useMemo(() =>
    filteredData.reduce((sum, d) => sum + (parseFloat(d.withdraw_amount_in_bdt) || 0), 0),
    [filteredData]
  );

  const todayTotal = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    return data
      .filter(d => d.createdAt?.slice(0, 10) === today)
      .reduce((sum, d) => sum + (parseFloat(d.withdraw_amount_in_bdt) || 0), 0);
  }, [data]);

  const thisMonthTotal = useMemo(() => {
    const now = new Date();
    return data
      .filter(d => {
        const date = new Date(d.createdAt);
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth();
      })
      .reduce((sum, d) => sum + (parseFloat(d.withdraw_amount_in_bdt) || 0), 0);
  }, [data]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const timeString = date.toLocaleString('en-US', options);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${timeString.toLowerCase()} ${day}.${month}.${year}`;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a { background-color: #0366d6; color: white; }
    li.disabled a { color: grey; background-color: #26B19B !important; }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

          <div className="row g-2 mb-2">

            <div className="col-6 col-md-3">
              <div className="card text-white bg-success">
                <div className="card-body py-2 px-2 d-flex justify-content-between align-items-center">
                  <div>
                    <small>Total</small>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      ৳{displayedTotal.toLocaleString('en-US')}
                    </div>
                  </div>
                  <i className="fa fa-money" style={{ fontSize: 18, opacity: 0.75 }}></i>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-white bg-info">
                <div className="card-body py-2 px-2 d-flex justify-content-between align-items-center">
                  <div>
                    <small>Today</small>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      ৳{todayTotal.toLocaleString('en-US')}
                    </div>
                  </div>
                  <i className="fa fa-calendar-check-o" style={{ fontSize: 18, opacity: 0.75 }}></i>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-white bg-warning">
                <div className="card-body py-2 px-2 d-flex justify-content-between align-items-center">
                  <div>
                    <small>Month</small>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      ৳{thisMonthTotal.toLocaleString('en-US')}
                    </div>
                  </div>
                  <i className="fa fa-calendar" style={{ fontSize: 18, opacity: 0.75 }}></i>
                </div>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card text-white bg-primary">
                <div className="card-body py-2 px-2 d-flex justify-content-between align-items-center">
                  <div>
                    <small>Records</small>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      {filteredData.length}
                    </div>
                  </div>
                  <i className="fa fa-list" style={{ fontSize: 18, opacity: 0.75 }}></i>
                </div>
              </div>
            </div>

          </div>
            <div className="card">
              <h4 className="card-title">Daily Withdraw Report</h4>

            <div className="card-header py-2">
                <div className="row g-2 align-items-end">

                  {/* User ID Search */}
                  <div className="col-12 col-md-3">
                    <small>User ID</small>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      value={userIdSearch}
                      onChange={(e) => setUserIdSearch(e.target.value)}
                    />
                  </div>

                  {/* Start Date */}
                  <div className="col-6 col-md-2">
                    <small>Start</small>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => { setStartDate(date); setActiveRange(""); }}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      className="form-control form-control-sm"
                      dateFormat="dd/MM/yy"
                      isClearable
                      placeholderText="Start"
                    />
                  </div>

                  {/* End Date */}
                  <div className="col-6 col-md-2">
                    <small>End</small>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => { setEndDate(date); setActiveRange(""); }}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      className="form-control form-control-sm"
                      dateFormat="dd/MM/yy"
                      isClearable
                      placeholderText="End"
                    />
                  </div>

                  {/* Show limit */}
                  <div className="col-6 col-md-1">
                    <small>Show</small>
                    <select
                      className="form-control form-control-sm"
                      value={limit}
                      onChange={(e) => {
                        setLimit(Number(e.target.value));
                        currentPage.current = 1;
                      }}
                    >
                      <option>10</option>
                      <option>30</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>

                  {/* Status */}
                  <div className="col-6 col-md-2">
                    <small>Status</small>
                    <select
                      className="form-control form-control-sm"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option>All</option>
                      <option>Pending</option>
                      <option>Paid</option>
                      <option>Reject</option>
                      <option>Adjust</option>
                    </select>
                  </div>

                  {/* Quick buttons */}
                  <div className="col-12 col-md-2">
                    <small>Quick</small>
                    <div className="btn-group w-100">

                      <button
                        className={`btn btn-sm ${activeRange === "today" ? "btn-info" : "btn-outline-info"}`}
                        onClick={handleToday}
                      >
                        T
                      </button>

                      <button
                        className={`btn btn-sm ${activeRange === "month" ? "btn-warning" : "btn-outline-warning"}`}
                        onClick={handleThisMonth}
                      >
                        M
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={handleReset}
                      >
                        R
                      </button>

                    </div>
                  </div>

                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-nowrap">#</th>
                        <th className="text-nowrap">User ID</th>
                        <th className="text-nowrap">Withdraw No</th>
                        <th className="text-nowrap">Agent ID</th>
                        <th className="text-nowrap">Amount (BDT)</th>
                        <th className="text-nowrap">Method</th>
                        <th className="text-nowrap">Date</th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center text-muted py-4">
                            No records found
                          </td>
                        </tr>
                      ) : (
                        filteredData.map((withdraw, index) => (
                          <tr key={withdraw._id || index}>
                            <td>{(currentPage.current - 1) * limit + index + 1}</td>
                            <td className="text-nowrap">{withdraw.user_id}</td>
                            <td className="text-nowrap">{withdraw.sender_number}</td>
                            <td className="text-nowrap">{withdraw.agent_id}</td>
                            <td className="text-nowrap">
                              ৳{parseFloat(withdraw.withdraw_amount_in_bdt).toLocaleString('en-US')}
                            </td>
                            <td className="text-nowrap">{withdraw.selected_method}</td>
                            <td className="text-nowrap">{formatDate(withdraw.createdAt)}</td>
                            <td>
                              {withdraw.status === 'Paid' ? (
                                <span className="badge badge-success">Paid</span>
                              ) : withdraw.status === 'Reject' ? (
                                <span className="badge badge-danger">Rejected</span>
                              ) : withdraw.status === 'Adjust' ? (
                                <span className="badge badge-info">Adjusted</span>
                              ) : (
                                <span className="badge badge-warning">Pending</span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex" style={{ gap: "4px" }}>
                                <button
                                  type="button"
                                  disabled={withdraw.status !== 'Pending'}
                                  className="btn btn-info btn-sm"
                                  onClick={(e) => handleApprovePayment(withdraw._id, 'Adjust', e)}
                                >
                                  Adjust
                                </button>
                                <button
                                  type="button"
                                  disabled={withdraw.status !== 'Pending'}
                                  className="btn btn-success btn-sm"
                                  onClick={(e) => handleApprovePayment(withdraw._id, 'Paid', e)}
                                >
                                  Approve
                                </button>
                                <button
                                  type="button"
                                  disabled={withdraw.status !== 'Pending'}
                                  className="btn btn-danger btn-sm"
                                  onClick={(e) => handleApprovePayment(withdraw._id, 'Reject', e)}
                                >
                                  Reject
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="table-secondary">
                        <td colSpan="4"><strong>Total</strong></td>
                        <td><strong>৳{displayedTotal.toLocaleString('en-US')}</strong></td>
                        <td colSpan="4"></td>
                      </tr>
                    </tfoot>
                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Daily_withdraw;